module.exports = __webpack_public_path__ + "static/media/isdoctorplan-spine-thoracic3@2x.a3c6d436.png";